<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Historial de Velocidades</h1>
		</div>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4 *ngIf="vehiculoInfo">{{vehiculoInfo.descripcion}}</h4>
			</div>
			<div class="col-md-12">
				<span>Especifique un rango de tiempo en el cual desea obtener información del vehiculo
					seleccionado.</span>
			</div>
		</div>
		<dx-validation-group *ngIf="showForm" #targetGroup>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12">
					<div class="row">
						<div class="col col-sm-12 col-md-4 col-lg-4">
							<label>Fecha Inicial</label>
							<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-4 col-lg-4">
							<label>Fecha Final</label>
							<dx-date-box [(value)]="fechaFin" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col col-sm-12 col-md-4 col-lg-4 mt-3">
							<div class="row mt-3">
								<button id="boton" type="submit" class="btn btn-success"
									(click)="reportePosicion(fechaInicio, fechaFin)"><i
										class="fal fa-search"></i>Buscar</button>&nbsp;
								<button id="boton" type="submit" [hidden]="!showPDFButton" class="btn btn-success"
									(click)="imprimirPdf()"><i class="fal fa-file-pdf"></i>Generar PDF</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div id="grafica" class="row mt-3">
			<div *ngIf="showGrafica" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-chart id="chart" [dataSource]="reporte">
					<dxi-series argumentField="fecha" valueField="velocidad" name="Velocidad" type="line"
						color="#52bb56">
					</dxi-series>
					<dxi-value-axis>
						<dxo-label [visible]="true" [customizeText]="etiquetaPie">
						</dxo-label>
					</dxi-value-axis>
					<dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
					<dxo-legend [margin]="1" horizontalAlignment="right" verticalAlignment="top"></dxo-legend>
					<dxo-tooltip [enabled]="true" [customizeTooltip]="etiquetaModificada" container="#grafica"></dxo-tooltip>
				</dx-chart>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" message='Cargando'>
</dx-load-panel>
